import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { classnames } from 'tailwindcss-classnames';

type ProductListAlertProps = {
  alert?: Field<string>;
};

const ProductListAlert = ({ alert }: ProductListAlertProps) => {
  const isExperienceEditor = useExperienceEditor();
  return (
    <>
      {isExperienceEditor || alert?.value ? (
        <div className={classnames('mb-2', 'w-full', 'rounded-md', 'bg-blue-night-tint')}>
          <div className={classnames('p-5', 'text-black')}>
            <RichTextA11yWrapper className={classnames('p-0', 'rte')} field={alert} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProductListAlert;
